import {
  dataTableFocusRing,
  activityToolbarButtonClass,
  drawerIconButtonClass,
} from 'features/activity/styles/dataTableStyles';

/**
 * Playground surface tokens. Everything here is the Traces / Settings look:
 * h-8 controls, hairline dividers, solid ember only for the one primary action.
 */
export { dataTableFocusRing, activityToolbarButtonClass, drawerIconButtonClass };

/** Primary: solid ember, on-brand text, h-8. */
export const primaryButtonClass =
  `inline-flex h-8 items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-brand px-3 text-[12px] font-medium text-[color:var(--text-on-brand)] transition-colors hover:bg-brand-hover disabled:cursor-not-allowed disabled:opacity-50 ${dataTableFocusRing}`;

/** Semibold section title over a hairline. */
export const sectionTitleClass =
  'flex items-center justify-between gap-2 border-b border-[color:var(--border-default)] pb-1.5 text-[13px] font-semibold text-[color:var(--text-primary)]';

/** Single-line field, h-8. */
export const inputClass =
  'h-8 w-full rounded-md border border-[color:var(--border-default)] bg-surface px-2.5 text-[12px] text-[color:var(--text-primary)] placeholder:text-[color:var(--text-disabled)] transition-[border-color] duration-150 focus:border-[color:var(--border-strong)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--state-focus-ring)]';

/** Anchored popover / menu panel. */
export const menuPanelClass =
  'rounded-lg border border-[color:var(--border-default)] bg-[color:var(--surface-raised,var(--surface-base))] py-1 shadow-token-lg';

/** One menu row. */
export const menuItemClass =
  'flex h-8 w-full items-center gap-2 px-3 text-left text-[12px] text-[color:var(--text-primary)] outline-none transition-colors hover:bg-surface-hover focus-visible:bg-surface-hover disabled:cursor-not-allowed disabled:opacity-50';

/** Modal shell, the same one Settings dialogs use. */
export const modalClass =
  'w-full rounded-lg border border-[color:var(--border-default)] bg-[color:var(--surface-raised,var(--surface-base))] shadow-token-lg';

export const modalOverlayStyle = { backgroundColor: 'var(--surface-overlay)' };

/** Quiet text-only action (Add variable, Add stop sequence). */
export const textButtonClass =
  `rounded text-[12px] font-medium text-[color:var(--text-muted)] transition-colors hover:text-[color:var(--text-primary)] disabled:opacity-50 ${dataTableFocusRing}`;
